var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState, useRef } from "react";
import { dispatchConfirmationDialogEvent } from "../../utils";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { UserMessageWrapper } from "./LLMMessageWrappers";
const UserContent = ({ content, deleteUserMessage, disableButtons, }) => {
    const [showButtons, setShowButtons] = useState(false);
    const hoverRef = useRef(false);
    const contentTextEl = content.find((e) => e.type === "text" && !e.is_viewer_state);
    // const contentSystemEl = content.find(
    //   (e) => e.type === "text" && e.is_viewer_state
    // );
    // const contentImageEl = content.find((e) => e.type === "image_url");
    const contentText = (contentTextEl === null || contentTextEl === void 0 ? void 0 : contentTextEl.text) || "";
    // const contentImage = contentImageEl?.image_url?.url || undefined;
    // let contentSystemName: string | undefined = undefined;
    // if (contentSystemEl && contentSystemEl.text) {
    //   try {
    //     const contentSystem = JSON.parse(contentSystemEl.text);
    //     contentSystemName = contentSystem.name;
    //   } catch {}
    // }
    // const theme = useTheme();
    // const chipColor = theme.palette.getContrastText("#4d4d4d");
    const handleMouseEnter = () => {
        hoverRef.current = true;
        setTimeout(() => {
            if (hoverRef.current) {
                setShowButtons(true);
            }
        }, 300);
    };
    const handleMouseLeave = () => {
        hoverRef.current = false;
        setShowButtons(false);
    };
    const copyUserMessage = () => {
        navigator.clipboard.writeText(contentText);
    };
    return (_jsxs(Box, Object.assign({ sx: { display: "flex", alignItems: "flex-end", flexDirection: "column" }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [_jsx(UserMessageWrapper, { children: contentText }), _jsx(Box, Object.assign({ sx: { visibility: showButtons ? "visible" : "hidden" } }, { children: _jsx(UserContentButtons, { copyUserrMessage: copyUserMessage, deleteUserMessage: deleteUserMessage, disabled: disableButtons }) }))] })));
};
const UserContentButtons = ({ copyUserrMessage, deleteUserMessage, disabled, }) => {
    const theme = useTheme();
    const textColor = theme.palette.getContrastText("#383838");
    const [justCopied, setJustCopied] = useState(false);
    const handleCopy = () => {
        copyUserrMessage();
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), 1000);
    };
    const handleDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        const ok = yield dispatchConfirmationDialogEvent({
            message: "Are you sure you want to delete this message?",
        });
        if (ok)
            deleteUserMessage();
    });
    return (_jsxs(Box, { children: [_jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Copy", onClick: () => {
                    handleCopy();
                }, baseColor: textColor, disabled: disabled }, { children: justCopied ? (_jsx(CheckIcon, { fontSize: "small" })) : (_jsx(ContentCopyIcon, { sx: { fontSize: "1rem" } })) })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Delete", onClick: () => {
                    handleDelete();
                }, baseColor: textColor, disabled: disabled }, { children: _jsx(DeleteOutlineIcon, { fontSize: "small" }) }))] }));
};
export default UserContent;
